import React from 'react';
import { Globe2, LogOut, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ duration = '05:09' }) => {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/60 border-b border-white/5">
      <div className="max-w-[1400px] mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="h-10 w-10 rounded-full border border-cyan-400/30 grid place-items-center bg-cyan-400/5">
            <Globe2 className="h-5 w-5 text-cyan-400" />
          </div>
          <div>
            <h1 className="text-cyan-400 font-bold text-lg leading-tight tracking-wide font-mono">Scraperino</h1>
            <p className="text-[10px] uppercase tracking-[0.15em] text-white/50 font-mono">Tableau de bord · KAVENDOR</p>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-2 pl-6">
          <span className="text-[10px] uppercase tracking-[0.2em] text-white/40 font-mono">Durée du run</span>
          <span className="font-mono text-xl text-white tabular-nums">{duration}</span>
        </div>

        <div className="flex items-center gap-3">
          <Button variant="outline" className="bg-transparent border-pink-500/50 text-pink-300 hover:bg-pink-500/10 hover:text-pink-200 font-mono uppercase text-[11px] tracking-widest">
            <span className="h-2 w-2 rounded-full bg-pink-500 mr-2 animate-pulse" />
            <AlertCircle className="h-3.5 w-3.5 mr-1" /> Incident à l'historique
          </Button>
          <Button variant="outline" className="bg-transparent border-white/15 text-white/80 hover:bg-white/5 font-mono text-[11px] uppercase tracking-wider">
            <LogOut className="h-3.5 w-3.5 mr-1.5" /> Déconnexion
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
